if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.initLocaleMap(); // ← 初始化語言映射表
        
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        
        if (this.elements.button) {
          this.elements.button.addEventListener('click', this.openSelector.bind(this));
        }

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        // 監聽 <a> 標籤點擊（Header 的選擇器）
        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
        
        // ✨ 新增：監聽 <select> 下拉選單（Footer 的選擇器）
        this.querySelectorAll('select').forEach((select) => {
          select.addEventListener('change', (event) => {
            const newValue = event.target.value;
            
            // 模擬 click event 來觸發 onItemClick
            const fakeEvent = {
              preventDefault: () => {},
              currentTarget: {
                dataset: { value: newValue }
              }
            };
            
            // 暫時更新 input 元素指向 select
            const originalInput = this.elements.input;
            this.elements.input = event.target;
            this.onItemClick(fakeEvent);
            this.elements.input = originalInput;
          });
        });
      }

      // ✨ 動態生成語言映射表
      initLocaleMap() {
        const configElement = document.querySelector('[data-locale-config]');
        const availableLanguages = configElement ? JSON.parse(configElement.textContent) : [];
        
        this.localeUrlMap = {};
        
        availableLanguages.forEach(item => {
          // 🔑 關鍵修正：從 shop_locale 取得語言資料
          const lang = item.shop_locale;
          if (!lang || !lang.locale) return;  // 防錯
          
          const code = lang.locale.toLowerCase();
          
          if (code === 'en' || code.startsWith('en-')) {
            // 英文無前綴
            this.localeUrlMap[lang.locale] = '';
          } else {
            // 其他語言：使用前兩個字元作為前綴
            const prefix = code.split('-')[0];
            this.localeUrlMap[lang.locale] = '/' + prefix;
          }
        });
        
        // 特殊規則（如果未來需要覆蓋自動生成的規則）
        const SPECIAL_RULES = {
          // 例如：'zh-CN': '/zh-cn'
        };
        this.localeUrlMap = { ...this.localeUrlMap, ...SPECIAL_RULES };
        
        console.log('✅ Dynamic locale map initialized:', this.localeUrlMap);
      }

      // 🔥 統一處理貨幣和語言切換
      onItemClick(event) {
        event.preventDefault();
        const input = this.elements.input;
        const newValue = event.currentTarget.dataset.value;
        
        if (input.name === 'country_code') {
          // 🌍 貨幣切換：改變 country 參數
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.set('country', newValue);
          console.log('🌍 Switching country to:', newValue);
          window.location.href = newUrl.toString();
          
        } else if (input.name === 'locale_code') {
          // 🗣️ 語言切換：改變路徑 + 保留 country 參數
          const currentPath = window.location.pathname;
          const currentParams = new URLSearchParams(window.location.search);
          const currentLocale = document.documentElement.lang || 'en';
          
          const currentPrefix = this.localeUrlMap[currentLocale] || '';
          const targetPrefix = this.localeUrlMap[newValue] || '';
          
          let targetPath = currentPath;
          
          // 移除當前語言前綴
          if (currentPrefix && targetPath.startsWith(currentPrefix)) {
            targetPath = targetPath.substring(currentPrefix.length) || '/';
          }
          
          // 添加目標語言前綴
          if (targetPrefix) {
            targetPath = targetPrefix + (targetPath === '/' ? '' : targetPath);
          }
          
          // 保留 country 參數
          const country = currentParams.get('country');
          if (country) {
            currentParams.set('country', country);
          }
          
          const queryString = currentParams.toString();
          const targetUrl = targetPath + (queryString ? '?' + queryString : '');
          
          console.log('🗣️ Switching language to:', newValue, '→', targetUrl);
          window.location.href = targetUrl;
        }
      }

      hidePanel() {
        if (!this.elements.button || !this.elements.panel) return;
        
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        const menuDrawer = document.querySelector('.menu-drawer');
        if (menuDrawer) {
          menuDrawer.classList.remove('country-selector-open');
        }
        if (this.header) {
          this.header.preventHide = false;
        }
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (!this.elements.button || this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (!this.elements.button || this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      openSelector() {
        if (!this.elements.button || !this.elements.panel) return;
        
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide') && this.header) {
          this.header.preventHide = true;
        }
        const menuDrawer = document.querySelector('.menu-drawer');
        if (menuDrawer) {
          menuDrawer.classList.add('country-selector-open');
        }
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        if (!this.elements.search) return;
        
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        if (this.elements.resetButton) {
          this.elements.resetButton.classList.toggle('hidden', !searchValue);
        }

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryElement = item.querySelector('.country');
          if (countryElement) {
            const countryName = this.normalizeString(countryElement.textContent);
            if (countryName.indexOf(searchValue) > -1) {
              item.parentElement.classList.remove('hidden');
              visibleCountries++;
            } else {
              item.parentElement.classList.add('hidden');
              visibleCountries--;
            }
          }
        });

        if (this.elements.liveRegion && window.accessibilityStrings) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        const countrySelector = this.querySelector('.country-selector');
        const countrySelectorList = this.querySelector('.country-selector__list');
        if (countrySelector) countrySelector.scrollTop = 0;
        if (countrySelectorList) countrySelectorList.scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.focus();
        }
      }

      onSearchFocus() {
        if (this.elements.searchIcon) {
          this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
        }
      }

      onSearchBlur() {
        if (this.elements.searchIcon && this.elements.search && !this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}